var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[_c('img',{staticStyle:{"width":"186px","height":"114px"},attrs:{"src":"https://cdn-image.yucrm.cn/images/tb-front-platform/images/default/newNotData.png"}}),_c('span',{staticClass:"empty-text"},[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }